( function() {
	const countyContainer = document.getElementById( 'member-filters__county' );
	const countyToggle = document.getElementById( 'county-toggle' );
	const countyList = document.getElementById( 'county-list' );
	const memberList = document.getElementById( 'member-list' );
	const culturalCheckbox = document.getElementById( 'cultural' );
	const countyLinks = countyList.getElementsByTagName( 'a' );
	let countyListOpen = false;

	countyToggle.setAttribute( 'aria-expanded', false );
	countyToggle.setAttribute( 'aria-controls', countyList.id );
	countyList.setAttribute( 'aria-hidden', true );

	function toggleCountyList() {
		countyToggle.setAttribute( 'aria-expanded', ! countyListOpen );
		countyList.setAttribute( 'aria-hidden', countyListOpen );
		countyListOpen = ! countyListOpen;
	}

	function toggleHighlight( e ) {
		const checked = e.target.checked;

		memberList.classList.toggle( 'highlight-cultural' );

		if ( 'function' === typeof URL ) {
			const url = new URL( window.location.href );
			const urlParams = new URLSearchParams( window.location.search );
			if ( checked ) {
				urlParams.set( 'cultural', '1' );
			} else {
				urlParams.delete( 'cultural' );
			}
			const newUrl = 'https://' + url.hostname + url.pathname + '?' + urlParams.toString() + url.hash;
			history.replaceState( null, '', newUrl );
		}
	}

	// esc key in form closes search and returns to toggle button
	countyContainer.addEventListener( 'keyup', function( e ) {
		if ( 27 === e.keyCode ) {
			if ( countyListOpen ) {
				toggleCountyList();
				countyToggle.focus();
			}
		}
	});

	culturalCheckbox.addEventListener( 'click', toggleHighlight );

	countyToggle.addEventListener( 'click', toggleCountyList );

	for ( let i = 0, len = countyLinks.length; i < len; i++ ) {
		countyLinks[i].addEventListener( 'click', toggleCountyList );
	}
}() );
